import axiosClient from "./../apiClient.js";

const baseEndpoint = "/masterdata";

export const getAlignments = () => {
  return axiosClient.get(`${baseEndpoint}/getalignments`);
};

export const getAreas = (taluka = 0) => {
  return axiosClient.get(`${baseEndpoint}/getareas?taluka=${taluka}`);
};

export const getBloodGroups = () => {
  return axiosClient.get(`${baseEndpoint}/getbloodgroups`);
};

export const getContentTypes = () => {
  return axiosClient.get(`${baseEndpoint}/getcontenttypes`);
};

export const getDirections = () => {
  return axiosClient.get(`${baseEndpoint}/getdirections`);
};

export const getDistricts = (state = 0) => {
  return axiosClient.get(`${baseEndpoint}/getdistricts?state=${state}`);
};

export const getGenders = () => {
  return axiosClient.get(`${baseEndpoint}/getgenders`);
};

export const getFounderTypes = () => {
  return axiosClient.get(`${baseEndpoint}/getfoundertypes`);
};

export const getMessageProcessingTypes = () => {
  return axiosClient.get(`${baseEndpoint}/getmessageprocessingtypes`);
};

export const getMessageTemplates = () => {
  return axiosClient.get(`${baseEndpoint}/getmessagetemplates`);
};

export const getOccupations = () => {
  return axiosClient.get(`${baseEndpoint}/getoccupations`);
};

export const getPhotoGalleryTypes = () => {
  return axiosClient.get(`${baseEndpoint}/getphotogallerytypes`);
};

export const getPhotoSizes = () => {
  return axiosClient.get(`${baseEndpoint}/getphotosizes`);
};

export const getQualifications = () => {
  return axiosClient.get(`${baseEndpoint}/getqualifications`);
};

export const getRequiredTypes = () => {
  return axiosClient.get(`${baseEndpoint}/getrequiredtypes`);
};

export const getStates = () => {
  return axiosClient.get(`${baseEndpoint}/getstates`);
};

export const getStatus = () => {
  return axiosClient.get(`${baseEndpoint}/getstatus`);
};

export const getSubscriptions = () => {
  return axiosClient.get(`${baseEndpoint}/getsubscriptions`);
};

export const getTalukas = (district = 0) => {
  return axiosClient.get(`${baseEndpoint}/gettalukas?district=${district}`);
};

export const getTitles = () => {
  return axiosClient.get(`${baseEndpoint}/gettitles`);
};

export const getUserTypes = () => {
  return axiosClient.get(`${baseEndpoint}/getusertypes`);
};

export const getVidyamanMandalTypes = () => {
  return axiosClient.get(`${baseEndpoint}/getvidyamanmandaltypes`);
};

export const getVishwasthaMandalTypes = () => {
  return axiosClient.get(`${baseEndpoint}/getvishwasthamandaltypes`);
};

export const getWedgitsNames = () => {
  return axiosClient.get(`${baseEndpoint}/getwedgitsnames`);
};

export const getYears = () => {
  return axiosClient.get(`${baseEndpoint}/getyears`);
};
